import { render, staticRenderFns } from "./open-tencent.vue?vue&type=template&id=3c0f8219&scoped=true&"
import script from "./open-tencent.vue?vue&type=script&lang=js&"
export * from "./open-tencent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0f8219",
  null
  
)

export default component.exports